var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLove = function SvgLove(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.51 11.92a6.3 6.3 0 0 0-8.92-.54L21 12.77l-1.6-1.4a6.3 6.3 0 0 0-8.91.55 7.42 7.42 0 0 0-.3 9.64 98.8 98.8 0 0 0 6.43 7.05 25.53 25.53 0 0 0 2.84 2.43c.88.63 1.37.78 1.54.78.17 0 .66-.15 1.54-.78.82-.57 1.78-1.41 2.84-2.43a98.8 98.8 0 0 0 6.44-7.05 7.42 7.42 0 0 0-.3-9.64ZM21.01 9.2a8.69 8.69 0 0 1 12.3.74c3.37 3.68 3.65 9.6.38 13.5-2.02 2.4-4.43 5.11-6.62 7.24a27.9 27.9 0 0 1-3.15 2.69c-.9.64-1.95 1.22-2.92 1.22s-2.02-.58-2.92-1.22a27.9 27.9 0 0 1-3.15-2.69 101.7 101.7 0 0 1-6.62-7.25c-3.27-3.89-3-9.81.38-13.49a8.69 8.69 0 0 1 12.3-.74H21Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/love.e542c48a16f67aa4b1d126e018c82ad2.svg";